// src/components/PrivacyPolicy.tsx
// 本文は src/content/legal.ts が正（静的HTML /privacy-policy と同じものを表示する）。
// ここに本文を書かないこと。書くと2か所に割れて片方だけ古くなる。
import React from 'react';
import { Box, Typography } from '@mui/material';
import { PRIVACY_POLICY } from '@/content/legal';

/** 本文中の **強調** を太字にする */
const renderLine = (line: string, key: number) => (
    <Typography variant="body2" paragraph key={key}>
        {line.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part))}
    </Typography>
);

const PrivacyPolicy: React.FC = () => (
    <Box sx={{ p: 2, textAlign: 'left' }}>
        <Typography variant="h5" gutterBottom>
            {PRIVACY_POLICY.title}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mb: 2, color: 'text.secondary' }}>
            最終更新: {PRIVACY_POLICY.updated}
        </Typography>
        {PRIVACY_POLICY.sections.map((s, si) => (
            <Box key={si}>
                {s.heading && <Typography variant="subtitle1">{s.heading}</Typography>}
                {s.body.map(renderLine)}
            </Box>
        ))}
    </Box>
);

export default PrivacyPolicy;
